/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:fa02363c-d69a-45e5-8711-7db53827aefd",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_qur8XIfGO",
    "aws_user_pools_web_client_id": "52m2334uda6su9q23qgn7dgdti",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://n2cxpgbl2e.execute-api.ap-south-1.amazonaws.com/prod",
            "region": "ap-south-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://brcwcxklyveqdgzmufwpxzv5fm.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
